import { render } from "./UpdateAccountView.vue?vue&type=template&id=a370a84a&scoped=true"
import script from "./UpdateAccountView.vue?vue&type=script&lang=js"
export * from "./UpdateAccountView.vue?vue&type=script&lang=js"

import "./UpdateAccountView.vue?vue&type=style&index=0&id=a370a84a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a370a84a"]])

export default __exports__